export default {"src":"/_next/static/media/flag-en.dc76d3d4.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};